import { c as _c } from "react/compiler-runtime";
import { Button, ButtonSize, ButtonVariant } from '@sprd/sprd-component-kit/v2';
import { ReactNode } from 'react';
import { useSetAtom } from 'jotai';
import { openPromoPopupAtom } from '@/atoms/promoAtom';
type PromoButtonProps = {
  size: ButtonSize;
  className?: string;
  variant?: ButtonVariant;
  children: ReactNode;
};
export const PromoButton = t0 => {
  const $ = _c(8);
  const {
    size,
    variant,
    className,
    children
  } = t0;
  const setOpenPopup = useSetAtom(openPromoPopupAtom);
  let t1;
  if ($[0] !== setOpenPopup) {
    t1 = () => {
      setOpenPopup(true);
    };
    $[0] = setOpenPopup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  const t2 = variant || "primary";
  let t3;
  if ($[2] !== children || $[3] !== className || $[4] !== handleClick || $[5] !== size || $[6] !== t2) {
    t3 = <Button size={size} variant={t2} className={className} onClick={handleClick}>{children}</Button>;
    $[2] = children;
    $[3] = className;
    $[4] = handleClick;
    $[5] = size;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};